'use strict';
var SuggestType;
(function (SuggestType) {
    SuggestType["Custom"] = "custom";
    SuggestType["HTML"] = "HTML";
    SuggestType["YOUTUBE_VIDEO"] = "YOUTUBE_VIDEO";
})(SuggestType || (SuggestType = {}));
export default SuggestType;
